import React from "react";
import cx from "classnames";

export function OpenedBook({ className, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 45 45"
      className={cx("OpenedBookIcon", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M17 28.176L7 24.175v3.385l10 4.001v-3.385zm0-10.385l-10-4v3.384l10 4.001v-3.385zM43.9.43a2.501 2.501 0 0 0-2.33-.251L22.5 7.808 3.43.179A2.501 2.501 0 0 0 0 2.5v32c0 1.022.62 1.941 1.57 2.321l19.96 7.983.48.147c.16.031.33.049.49.049.16 0 .32-.018.49-.049l.48-.148 19.96-7.982A2.498 2.498 0 0 0 45 34.5v-32c0-.83-.41-1.605-1.1-2.07zM20 39.885l-16-6.4V5.465l16 6.401v28.019zm21-6.4l-16 6.4V11.866l16-6.401v28.02zm-3-9.31l-10 4.001v3.385l10-4.001v-3.385zm0-10.384l-10 4v3.385l10-4.001v-3.384z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/modules/icons/index.js